import Image from 'next/image'
import Link from 'next/link'

import { Card } from '@wartek-id/card'
import { Text } from '@wartek-id/text-v1'
import { Badge } from '@wartek-id/badge'
import { Button } from '@wartek-id/button-v1'
import { Icon } from '@wartek-id/icon-v2'
import { Shimmer } from '@wartek-id/shimmer'

import { PENGELOLAAN_KINERJA_KS_PENILAI_PATH } from 'app/KinerjaShared/constants/path'
import { PANDUAN_PENGELOLAAN_URL } from 'app/KinerjaShared/utils/panduan'

import type { Kinerja, KinerjaProfil } from 'types/kinerja'

interface CardKinerjaPeriksaProps {
  period: Kinerja['period']
  isLoading?: boolean
  profile: KinerjaProfil

  baseUrl?: string
  title?: string
  subtitle?: string
  badgeText?: string
}

export default function CardKinerjaPeriksa({
  period = 1,
  isLoading = false,
  profile,
  baseUrl = PENGELOLAAN_KINERJA_KS_PENILAI_PATH,
  title = 'Periksa Perencanaan Kinerja',
  subtitle = 'Mohon cek dan setujui. Anda juga bisa memberikan penyesuaian jika diperlukan.',
  badgeText = 'Khusus Kepala Sekolah',
}: CardKinerjaPeriksaProps) {
  return (
    <Card className="p-6">
      <div className="flex gap-6">
        <Image alt="" src="/icon/typing-monitor.png" width={84} height={84} />
        <div className="flex-1 flex flex-col gap-1 justify-center">
          <Text
            variant="subheading"
            color="informational"
            className="!text-blue-60 !uppercase tracking-[0.5px]"
          >
            {period === 1 ? '1-31 Januari' : '1-31 Juli'}
          </Text>
          <div className="flex items-center gap-2">
            <Text variant="heading-lg">{title}</Text>
            <Badge className="uppercase">{badgeText}</Badge>
          </div>
          <Text color="subdued">{subtitle}</Text>
        </div>
      </div>

      <div className="border border-gray-20 rounded-lg p-6 flex gap-2 justify-between w-1/2 mt-6">
        {isLoading ? (
          <Shimmer />
        ) : (
          <>
            <div>
              <Text variant="heading-sm">{profile.satuanPendidikan}</Text>
              <Text color="subdued">{profile.npsn}</Text>
            </div>
            <Link href={`${baseUrl}/periksa/${profile.npsn}`} passHref>
              <Button color="black">Periksa</Button>
            </Link>
          </>
        )}
      </div>

      <div className="rounded bg-cyan-5 p-3 mt-6 flex items-center">
        <Icon color="informational" className="mr-1">
          error
        </Icon>
        Jika satuan pendidikan tidak sesuai, mohon kunjungi&nbsp;
        <a
          className="!text-blue-70 underline"
          href={PANDUAN_PENGELOLAAN_URL}
          target="_blank"
          rel="noreferrer"
        >
          Pusat Bantuan
        </a>
        .
      </div>
    </Card>
  )
}
